import React from "react";

const Image = ({ media, render }) =>
  render({
    media: media,
    image: media
  });

const Carousel = ({ media, render }) => {
  const index = media.schmodel_carousel_media_index;
  if (index !== undefined) {
    return (
      <React.Fragment>
        {render({
          media,
          image: media.children.data[index]
        })}
      </React.Fragment>
    );
  } else {
    return (
      <React.Fragment>
        {media.children.data
          .filter(media => media.media_type === "IMAGE")
          .map((image, index) =>
            render({
              media: { ...media, schmodel_carousel_media_index: index },
              image
            })
          )}
      </React.Fragment>
    );
  }
};

const types = {
  IMAGE: Image,
  CAROUSEL_ALBUM: Carousel
};

let InstagramMedia = ({ media, render }) => {
  return (
    <React.Fragment>
      {media?.media_type && types[media.media_type] &&
        React.createElement(types[media.media_type], { media, render })}
    </React.Fragment>
  );
};

InstagramMedia.toId = media => {
  if (media.schmodel_carousel_media_index) {
    return media.id + `->${media.schmodel_carousel_media_index}`;
  }

  return media.id;
};

export default InstagramMedia;
